export default __webpack_public_path__ + "static/media/bgnecro.effc796d.jpg";